// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"book","328":"admin","535":"login","685":"register"}[chunkId] + "." + {"112":"04367c99","328":"a00e9b13","535":"ac4743b4","685":"f320a367"}[chunkId] + ".js";
};